module.exports = __webpack_public_path__ + "media/assets/icons/whatsapp-grey-c1f374f551cc76ccdeaeaba0a857e542.svg";